// import "jquery-mousewheel";
class Core {
    constructor() {
        this.currentTimeout = null;
    };
    wait(timeout) {
        if (this.currentTimeout) {
            clearTimeout(this.currentTimeout);
        };
        return new Promise(resolve => {
            this.currentTimeout = setTimeout(resolve, timeout);
        });
    };
};


const scrollFrame = {
    el: {
        scrollFrame: '.scrollFrame',
        frame: [],
        nav: '.scrollFrameControl',
        scrollContainer: 'html',
        fullPageWrapper: 'body'
    },
    data: {
        totalFrame: 0, 
        currentFrame: 0,
        currentFrameId: '',
        aniComplete: true,
        timeAnimation: 500,
    },
    func: {
        getTotalFrame: () => $(scrollFrame.el.scrollFrame).length,
        getScaleRatio: () => {
            if ($(scrollFrame.el.fullPageWrapper).length > 0) {
                return ($(scrollFrame.el.fullPageWrapper).attr("data-scale-ratio"));
            } else {
                return 1;
            }
        },
        getFrames: () => {
            $(scrollFrame.el.scrollFrame).each(function(){
                // scrollFrame.el.frame.push("#"+$(this).attr("id"));
                scrollFrame.el.frame.push({
                    el: "#"+$(this).attr("id"),
                    offsetTop: $("#"+$(this).attr("id")).offset().top
                })
            });
        },
        getFrameOffset: (frameId) => {
            for (let i = 0, len = scrollFrame.el.frame.length; i < len; i++) {
                if (scrollFrame.el.frame[i].el === frameId) {
                    return scrollFrame.el.frame[i].offsetTop;
                }
            }
            return 0;

        },
        scrollTo: (frameId, scrollOffset) => {
            // let scrollTop = $(frameId).offset().top;
            let scaleRatio = scrollFrame.func.getScaleRatio();
            // console.log(scaleRatio);
            // scrollTop *= scaleRatio;
            // console.log(frameId);
            // console.log(scrollTop);
            let scrollTop = scrollFrame.func.getFrameOffset(frameId);

            // console.log(parseInt(scrollOffset));
            // console.log(scrollFrame.func.getScaleRatio());
            scrollTop *= scaleRatio;
            // if (scrollOffset != undefined) {
            //     // scrollTop += parseInt(scrollOffset) * scrollFrame.func.getScaleRatio();
            //     scrollTop *= scaleRatio;
            //
            // }

            // console.log(scrollTop);

            $(scrollFrame.el.scrollContainer).animate({
                scrollTop: scrollTop
            }, scrollFrame.data.timeAnimation, 'linear', function(){
                scrollFrame.data.aniComplete = true;
            });

            scrollFrame.func.activeNavBullet(frameId);
        },
        activeNavBullet: (frameId) => {
            if ($(scrollFrame.el.nav).length > 0) {
                $(scrollFrame.el.nav).removeClass("active");
                $(scrollFrame.el.nav).parent().parent().find('[href="'+frameId+'"]').addClass("active");
                 $(scrollFrame.el.nav).find('a').removeClass("active");
                 $(scrollFrame.el.nav).find('a[href="'+frameId+'"]').addClass("active");
            }
        },
        isOpeningPopup: () => {
            return $("html").hasClass("popup-opened");
        }
    },
    handleMousewheel: () => {
        $(window).on("mousewheel", function(e){
            // e.preventDefault();
            // e.stopPropagation();
            if (!scrollFrame.func.isOpeningPopup()) {

                let deltaY = e.deltaY;

                // console.log(deltaY, scrollFrame.data.aniComplete, scrollFrame.data.currentFrameId);
                // console.log(deltaY > 0 && scrollFrame.data.aniComplete && (scrollFrame.data.currentFrame + 1 < scrollFrame.data.totalFrame));
                if (deltaY < 0 && scrollFrame.data.aniComplete && (scrollFrame.data.currentFrame + 1 < scrollFrame.data.totalFrame)) {
                    // Scroll down
                    scrollFrame.data.currentFrame ++;
                    scrollFrame.data.aniComplete = false;
                    scrollFrame.data.currentFrameId = scrollFrame.el.frame[scrollFrame.data.currentFrame].el;
                    scrollFrame.func.scrollTo(scrollFrame.data.currentFrameId);
    
                } else if (deltaY > 0 && scrollFrame.data.aniComplete && (scrollFrame.data.currentFrame > 0))  {
                    // Scroll up
                    scrollFrame.data.currentFrame --;
                    scrollFrame.data.aniComplete = false;
                    scrollFrame.data.currentFrameId = scrollFrame.el.frame[scrollFrame.data.currentFrame].el;
                    scrollFrame.func.scrollTo(scrollFrame.data.currentFrameId);
                }
            }
        });
    },

    
    // handleNav: () => {
    //     if ($(scrollFrame.el.nav).length > 0) {
    //         // Kiểm tra nếu URL có hash
    //         const hash = window.location.hash;
    
    //         // Nếu không có hash trong URL, mặc định chọn frame tqht_mansite_header
    //         let defaultFrame = hash ? hash : '#tqht_mansite_header';
    
    //         // Nếu có hash trong URL hoặc mặc định là tqht_mansite_header
    //         $(scrollFrame.el.nav).on("click", function (e) {
    //             e.preventDefault();
    
    //             let frameToScroll = $(this).attr("href");
    
    //             // Nếu có data-fts-selector thì xác định lại frame
    //             const ftsSelector = $(this).attr("data-fts-selector");
    //             if (ftsSelector && ftsSelector.length > 0) {
    //                 const targetEl = $(ftsSelector); // ftsSelector là selector, ví dụ: [data-block-id="abc"]
    //                 frameToScroll = "#" + targetEl.attr("id");
    
    //                 // Chỉ khi click mới xóa và thêm class active
    //                 $(".scrollFrame").removeClass("active");
    //                 $(frameToScroll).addClass("active");
    
    //                 // Cập nhật URL với hash của frame đang active
    //                 window.history.pushState(null, null, frameToScroll); // Cập nhật URL mà không tải lại trang
    
    //                 // Cập nhật các class liên quan
    //                 if (frameToScroll === '#tqht_mansite_header') {
    //                      $(".floatleft__main, .container_floatright, .floatright_nap, .floatright_download, .floatright_nhapcode, .floatright_hotro").removeClass("active");
    //                 } else {
    //                      $(".floatleft__main, .container_floatright, .floatright_nap, .floatright_download, .floatright_nhapcode, .floatright_hotro").addClass("active");
    //                 }
    //             }
    
    //             for (let i = 0, len = scrollFrame.el.frame.length; i < len; i++) {
    //                 if (scrollFrame.el.frame[i].el === frameToScroll) {
    //                     scrollFrame.data.currentFrame = i;
    //                     scrollFrame.data.currentFrameId = frameToScroll;
    //                 }
    //             }
    
    //             var scrollOffset = $(this).attr("data-scroll-offset");
    //             scrollFrame.func.scrollTo(frameToScroll, scrollOffset);
    //         });
    
    //         // Kiểm tra nếu không có hash thì tự động active phần tử mặc định
    //         if (!hash) {
    //             $(".scrollFrame").removeClass("active");
    //             $(defaultFrame).addClass("active");
    //             window.history.pushState(null, null, defaultFrame); // Cập nhật URL với phần tử mặc định
    //         }
    //     }
    // },
    handleNav: () => {
        if ($(scrollFrame.el.nav).length > 0) {
            const hash = window.location.hash;
            let defaultFrame = hash ? hash : '#tqht_mansite_header';
            const frameExists = $(defaultFrame).length > 0;
    
            if (frameExists) {
                // Bỏ tất cả active
                $(".scrollFrame").removeClass("active");
                $(scrollFrame.el.nav).removeClass("active");
    
                // Active frame và nav tương ứng
                $(defaultFrame).addClass("active");
                $(`.scrollFrameControl[href="${defaultFrame}"]`).addClass("active");
    
                // Cập nhật URL nếu không có hash ban đầu
                if (!hash) {
                    window.history.pushState(null, null, defaultFrame);
                }
    
                // Cập nhật class liên quan
                if (defaultFrame === '#tqht_mansite_header') {
                     $(".floatleft__main, .container_floatright, .floatright_nap, .floatright_download, .floatright_nhapcode, .floatright_hotro").removeClass("active");
                } else {
                     $(".floatleft__main, .container_floatright, .floatright_nap, .floatright_download, .floatright_nhapcode, .floatright_hotro").addClass("active");
                }
    
                // Gán currentFrame
                for (let i = 0, len = scrollFrame.el.frame.length; i < len; i++) {
                    if (scrollFrame.el.frame[i].el === defaultFrame) {
                        scrollFrame.data.currentFrame = i;
                        scrollFrame.data.currentFrameId = defaultFrame;
                    }
                }
            }
    
            // Gán sự kiện click cho nav
            $(scrollFrame.el.nav).on("click", function (e) {
                e.preventDefault();
    
                let frameToScroll = $(this).attr("href");
    
                // Nếu có data-fts-selector thì lấy lại frame từ selector
                const ftsSelector = $(this).attr("data-fts-selector");
                if (ftsSelector && ftsSelector.length > 0) {
                    const targetEl = $(ftsSelector);
                    frameToScroll = "#" + targetEl.attr("id");
                }
    
                // Bỏ active tất cả
                $(".scrollFrame").removeClass("active");
                $(scrollFrame.el.nav).removeClass("active");
    
                // Active lại frame và nav tương ứng
                $(frameToScroll).addClass("active");
                $(`.scrollFrameControl[href="${frameToScroll}"]`).addClass("active");
    
                // Cập nhật URL hash
                window.history.pushState(null, null, frameToScroll);
    
                // Cập nhật class liên quan
                if (frameToScroll === '#tqht_mansite_header') {
                     $(".floatleft__main, .container_floatright, .floatright_nap, .floatright_download, .floatright_nhapcode, .floatright_hotro").removeClass("active");
                } else {
                     $(".floatleft__main, .container_floatright, .floatright_nap, .floatright_download, .floatright_nhapcode, .floatright_hotro").addClass("active");
                }
    
                // Gán lại current frame
                for (let i = 0, len = scrollFrame.el.frame.length; i < len; i++) {
                    if (scrollFrame.el.frame[i].el === frameToScroll) {
                        scrollFrame.data.currentFrame = i;
                        scrollFrame.data.currentFrameId = frameToScroll;
                    }
                }
    
                // Scroll tới frame
                const scrollOffset = $(this).attr("data-scroll-offset");
                scrollFrame.func.scrollTo(frameToScroll, scrollOffset);
            });
        }
    },
    
     
      init: () => {
        // console.log("scroll frame initial");
        // $(scrollFrame.el.scrollContainer).animate({
        //     scrollTop: 0
        // }, scrollFrame.data.timeAnimation, 'linear', function(){});

        scrollFrame.data.totalFrame = scrollFrame.func.getTotalFrame();
        scrollFrame.func.getFrames();

        // console.log(scrollFrame.el.frame)

        // console.log(scrollFrame.el);
        // console.log(scrollFrame.data);
        //scrollFrame.handleMousewheel();
        scrollFrame.handleNav();
    }
}

export default scrollFrame;


